import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: [],
  error: null
});

function rawInspectionDataForDomainReducer(state = initialState, action) {
  switch (action.type) {
    case ActionNames.REQUEST_GSC_SEO_HEALTH_INSPECTION_FOR_PLATFORM:
      return state.merge({ data: [], loading: true });
    case ActionNames.RECEIVE_GSC_SEO_HEALTH_INSPECTION_FOR_PLATFORM:
      return state.merge({ data: action.data, loading: false });
    case ActionNames.FAILURE_GSC_SEO_HEALTH_INSPECTION_FOR_PLATFORM:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default rawInspectionDataForDomainReducer;
